import { useEffect } from "react";
import PaymentMethodService from "../../../services/PaymentMethodService";
import { useAppSelector } from "../../../store/hooks";
import { useNavigate } from "react-router-dom";
import { SectionHeading } from "../../ui/Fonts";
import Popup from "../../layout/Popup";
import { useTranslation } from "react-i18next";
import Spinner from "../../ui/Spinner";
import toast from "react-hot-toast";

export default function QuickpayCallback() {
  const account = useAppSelector((state) => state.account.account);
  const maxWaitTime = 10 * 1000; // 10 seconds
  const { t } = useTranslation();

  const navigate = useNavigate();

  useEffect(() => {
    if (!account?.code) {
      return;
    }

    const interval = setInterval(() => {
      fetchPendingPaymentCards();
    }, 2000);

    /**
     * If the user still have pending payment cards after 10 seconds,
     * show an error message and redirect to the dashboard
     */
    const timeout = setTimeout(() => {
      clearInterval(interval);

      toast.error(t("payment_methods.quickpay-callback-error"));

      navigate("/");
    }, maxWaitTime);

    const fetchPendingPaymentCards = async () => {
      if (!account?.code) {
        navigate("/");
        return;
      }

      const res = await new PaymentMethodService().getPendingPaymentCards(
        account?.code
      );

      if (res.count === 0) {
        toast.success(t("payment_methods.quickpay-callback-success"));
        clearInterval(interval);
        clearTimeout(timeout);
        navigate("/");
      }
    };

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [account, t, navigate, maxWaitTime]);

  return (
    <Popup>
      <div className={"flex flex-col items-center"}>
        <SectionHeading>
          {t("payment_methods.quickpay-callback-title")}
        </SectionHeading>
        <Spinner />
      </div>
    </Popup>
  );
}
